module.exports = __webpack_public_path__ + "img/flag_221.8f2fba69.png";